var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
var fetchFromBackend = function (_a, addresses) {
    var apiUrl = _a.apiUrl, timeout = _a.timeout, chainId = _a.chainId;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post("".concat(apiUrl, "/v1/mints?chainId=").concat(chainId), {
                            addresses: addresses.map(function (address) { return address.toString(); })
                        }, { timeout: timeout })];
                case 1:
                    response = _b.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    e_1 = _b.sent();
                    throw e_1;
                case 3: return [2 /*return*/];
            }
        });
    });
};
var searchFromBackend = function (_a, query, _b) {
    var apiUrl = _a.apiUrl, timeout = _a.timeout, chainId = _a.chainId;
    var start = _b.start, limit = _b.limit;
    return __awaiter(void 0, void 0, void 0, function () {
        var response, e_2;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.get("".concat(apiUrl, "/v1/search?query=").concat(query, "&start=").concat(start, "&limit=").concat(limit, "&chainId=").concat(chainId), { timeout: timeout })];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    e_2 = _c.sent();
                    throw e_2;
                case 3: return [2 /*return*/];
            }
        });
    });
};
export var fetchTokensBackend = function (config, mints) { return __awaiter(void 0, void 0, void 0, function () {
    var content, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetchFromBackend(config, mints)];
            case 1:
                content = (_a.sent()).content;
                return [2 /*return*/, content];
            case 2:
                e_3 = _a.sent();
                throw e_3;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var searchTokensBackend = function (config, query, options) { return __awaiter(void 0, void 0, void 0, function () {
    var content, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, searchFromBackend(config, query, options)];
            case 1:
                content = (_a.sent()).content;
                return [2 /*return*/, content];
            case 2:
                e_4 = _a.sent();
                throw e_4;
            case 3: return [2 /*return*/];
        }
    });
}); };
